import { useCallback } from "react";
import { useQueryClient } from "../../../context/QueryClientContext";

export const usePortfolioQueryModifications = () => {
  const queryClient = useQueryClient();

  const flushData = useCallback(
    (id?: string) => {
      if (!id) {
        queryClient.invalidateQueries({ queryKey: ["models"] });
      } else {
        try {
          queryClient.invalidateQueries({ queryKey: ["model", id] });
          queryClient.invalidateQueries({ queryKey: ["model", "chart", id] });
          queryClient.invalidateQueries({ queryKey: ["model", "table", id] });
          queryClient.invalidateQueries({ queryKey: ["model", "returns", id] });
          queryClient.invalidateQueries({
            queryKey: ["model", "current-returns", id],
          });
          queryClient.invalidateQueries({
            queryKey: ["model", "aggregated-returns", id],
          });
          queryClient.invalidateQueries({
            queryKey: ["model", "drawdown", id],
          });
          queryClient.invalidateQueries({
            queryKey: ["model", "turnover", id],
          });
        } catch (error) {
          console.error("Error flushing portfolio data:", error);
        }
      }
    },
    [queryClient]
  );

  const emptyData = useCallback(
    (id: string) => {
      try {
        queryClient.setQueryData(["model", id], () => []);
        queryClient.setQueryData(["model", "chart", id], () => ({}));
        queryClient.setQueryData(["model", "table", id], () => ({}));
        queryClient.setQueryData(["model", "returns", id], () => ({}));
        queryClient.setQueryData(["model", "current-returns", id], () => ({}));
        queryClient.setQueryData(
          ["model", "aggregated-returns", id],
          () => ({})
        );
        queryClient.setQueryData(["model", "drawdown", id], () => ({}));
        queryClient.setQueryData(["model", "turnover", id], () => ({}));
      } catch (error) {
        console.error("Error emptying portfolio data:", error);
      }
    },
    [queryClient]
  );

  const refetchData = useCallback(
    (id: string) => {
      try {
        queryClient.refetchQueries({
          queryKey: ["model", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "chart", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "table", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "returns", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "current-returns", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "aggregated-returns", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "drawdown", id],
        });
        queryClient.refetchQueries({
          queryKey: ["model", "turnover", id],
        });
      } catch (error) {
        console.error("Error refetching portfolio data:", error);
      }
    },
    [queryClient]
  );

  return { emptyData, refetchData, flushData };
};
